import { sendToApi } from 'api/client'

export const StripeCheckoutSessionClient = {
  create: async (workspace_id: number, success_url?: string, cancel_url?: string) => {
    return sendToApi<{ session_id: string }>('/stripe/checkout_sessions', {
      method: 'POST',
      body: { workspace_id, success_url, cancel_url },
    })
  },
  updatePaymentMethod: async (sessionId: string) => {
    return sendToApi(`/stripe/checkout_sessions/${sessionId}/update_payment_method`, { method: 'PUT' })
  },
}
